import { GRAPHQL_ENDPOINT, SITE } from "@api/constants";
import registrationInfoRequestUpdateMutation from "@api/mutations/registration-info-request-update";
import RegistrationInfoRequest from "@api/types/registration-info-request";

type Response = {
  data: {
    registrationInfoRequestUpdate: {
      id: string;
      registrationInfo: {
        data: {
          code: string;
          value: string;
        };
      };
    };
  };
};

const registrationInfoRequestUpdate = async (
  token: string,
  request: RegistrationInfoRequest
): Promise<Response> => {
  const body = {
    query: registrationInfoRequestUpdateMutation,
    variables: {
      request,
    },
  };

  const response = await fetch(GRAPHQL_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CORE-SITE": SITE,
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(body),
  });
  return (await response.json()) as Response;
};

export default registrationInfoRequestUpdate;
